"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../svg/Icon");
var _TextInput = require("../text-input/TextInput");
var _Alert = require("../alert/Alert");
var _Tag = require("../tag/Tag");
var _PillGroup = require("../../components/pill/PillGroup");
var _Divider = require("../../components/divider/Divider");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var emptyDivClassName = 'tl-empty-tag';
var Dropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(Dropdown, _React$Component);
  var _super = _createSuper(Dropdown);
  function Dropdown(props) {
    var _this;
    _classCallCheck(this, Dropdown);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "innerHeaderRef", void 0);
    _defineProperty(_assertThisInitialized(_this), "dropdownRef", void 0);
    _defineProperty(_assertThisInitialized(_this), "debounced", function (delay, fn) {
      var timerId;
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (timerId) {
          clearTimeout(timerId);
        }
        timerId = setTimeout(function () {
          fn.apply(void 0, args);
          timerId = null;
        }, delay);
      };
    });
    _defineProperty(_assertThisInitialized(_this), "onResizeMultiSelection", function () {
      _this.setState({
        showFromIndex: 0,
        optionAdded: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "generateSelectionList", function (showFromIndex) {
      var removeFilterSelection = _this.props.removeFilterSelection;
      var finalArray = Array.isArray(_this.props.values) && _this.props.values.slice(showFromIndex).map(function (option) {
        var currentEl = /*#__PURE__*/React.createElement(_Tag.Tag, {
          key: option,
          label: option,
          className: "tl-tag-margin-bottom-reset tl-content-center tl-tag-option-selected",
          onLabelClick: function onLabelClick(e) {
            return e.stopPropagation();
          },
          onKeyDown: _this.onTagKeyDown,
          onCloseClick: function onCloseClick(e) {
            e.stopPropagation();
            removeFilterSelection && removeFilterSelection(option);
            _this.setState({
              optionAdded: true,
              showFromIndex: 0
            });
          }
        });
        return currentEl;
      });
      return finalArray;
    });
    _defineProperty(_assertThisInitialized(_this), "renderHeader", function () {
      var _this$props$values;
      var selectedTwoColumnOption = _this.props.options.find(function (o) {
        return o.displayTextRight && o.itemId === _this.props.value;
      });
      var dropDownIconClassName = _this.props.dropDownButton ? 'tl-dropdown-button-icon' : 'tl-dropdown-icon';
      var openIcon = _this.props.openIcon || "icon-system-chevron-up";
      var closedIcon = _this.props.closedIcon || "icon-system-chevron-down";
      var showFromIndex = _this.state.showFromIndex;
      return /*#__PURE__*/React.createElement("div", {
        id: _this.props.dropdownId,
        className: "tl-dropdown-header ".concat(_this.props.headerClassName),
        onClick: _this.toggleDropdown,
        onFocus: _this.props.onFocus,
        onBlur: function onBlur(event) {
          var headerComponent = document.getElementById(_this.props.dropdownId);
          var childInParent = headerComponent === null || headerComponent === void 0 ? void 0 : headerComponent.contains(event.relatedTarget);
          // this is basically to re arrange the values array so that is show +x
          if (_this.props.multiSelection && !childInParent) _this.setState({
            optionAdded: true
          });
          if (_this.props.onBlur) _this.props.onBlur(event);
        },
        onKeyDown: _this.onKeyDown,
        onDoubleClick: _this.props.onDblClick,
        onMouseOver: _this.props.onMouseOver,
        onMouseOut: _this.props.onMouseOut,
        tabIndex: 0
      }, _this.props.label && !_this.props.selectionOverride && /*#__PURE__*/React.createElement("div", {
        className: "tl-dropdown-label ".concat(_this.props.value || (_this$props$values = _this.props.values) !== null && _this$props$values !== void 0 && _this$props$values.length || _this.props.placeholder ? "tl-label-up" : "")
      }, _this.props.label), _this.props.selectionOverride ? _this.props.selectionOverride : /*#__PURE__*/React.createElement(React.Fragment, null, _this.props.multiSelection ? /*#__PURE__*/React.createElement("div", {
        className: "tl-dropdown-display tl-content-center ".concat(_this.state.isOpen && "dropdown-open")
      }, /*#__PURE__*/React.createElement("div", {
        ref: _this.innerHeaderRef,
        className: "tl-tag-container"
      }, showFromIndex && _this.props.values.length ? /*#__PURE__*/React.createElement(_Tag.Tag, {
        label: "+".concat(showFromIndex),
        onKeyDown: _this.onTagKeyDown,
        hideIcon: true,
        onLabelClick: function onLabelClick(e) {
          e.stopPropagation();
          _this.setState({
            showFromIndex: 0
          }, function () {
            return _this.focusTheHeader();
          });
        },
        className: "tl-tag-margin-bottom-reset tl-tag-hidden-count"
      }) : null, _this.generateSelectionList(_this.state.showFromIndex), /*#__PURE__*/React.createElement("div", {
        className: "".concat(emptyDivClassName)
      }, "4"))) : _this.props.dropDownButton ? /*#__PURE__*/React.createElement("div", {
        className: "tl-dropdown-button-display ".concat(_this.props.inputClassName, " ").concat(_this.props.placeholderClassName, " ").concat(_this.state.isOpen && "dropdown-open")
      }, _this.props.value ? _this.props.value : 'placeholder') : selectedTwoColumnOption ? /*#__PURE__*/React.createElement("div", {
        className: "tl-dropdown-display ".concat(_this.props.inputClassName, " ").concat(_this.state.isOpen && "dropdown-open")
      }, /*#__PURE__*/React.createElement("div", {
        className: "tl-two-column-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tl-dropdown-option-left"
      }, selectedTwoColumnOption.displayText), /*#__PURE__*/React.createElement("div", {
        className: "tl-dropdown-option-right"
      }, selectedTwoColumnOption.displayTextRight))) : /*#__PURE__*/React.createElement("input", {
        className: "tl-dropdown-display ".concat(_this.props.inputClassName, " ").concat(_this.state.isOpen && "dropdown-open"),
        readOnly: true,
        value: _this.props.value,
        placeholder: _this.props.placeholder,
        title: _this.props.value || _this.props.placeholder,
        type: "text",
        tabIndex: -1
      }), _this.renderAssistiveText()), !_this.props.selectionOverride && /*#__PURE__*/React.createElement(_Icon.SvgIcon, {
        name: _this.state.isOpen ? openIcon : closedIcon,
        className: dropDownIconClassName
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "handleCrossIconClick", function (e) {
      _this.setState({
        searchText: ''
      });
      if (_this.props.onCrossIconClicked) {
        _this.props.onCrossIconClicked(e);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "searchOnChange", function (event) {
      _this.setState({
        searchText: event.target.value
      });
      if (_this.props.searchOnChange) {
        _this.props.searchOnChange(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "stickyFooterFocus", function () {
      if (_this.props.stickyFooterDiv) {
        var parentElem = document.getElementById("".concat(_this.props.dropdownId, "-container"));
        if (parentElem && !parentElem.contains(document.activeElement)) {
          _this.closeDropdown();
        }
      } else {
        _this.closeDropdown();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (event) {
      var parentElem = document.getElementById("".concat(_this.props.dropdownId, "-container"));
      if (parentElem && !parentElem.contains(event.target)) {
        _this.closeDropdown();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onOptionClick", function (event) {
      if (_this.props.onOptionClick) {
        var inputElem = document.getElementById(_this.props.dropdownId);
        inputElem !== null && inputElem.focus();
        _this.props.onOptionClick(event);
      }
      if (_this.props.multiSelection) _this.setState({
        optionAdded: true
      });else _this.closeDropdown();
    });
    _defineProperty(_assertThisInitialized(_this), "onSearchKeyDown", function (event) {
      var dropdownContent = document.getElementById(_this.props.dropdownId + "-dropdown-options");
      if (event.key === "ArrowDown" && dropdownContent !== null) {
        var children = dropdownContent.children;
        for (var i = 0; i < children.length; i += 1) {
          if (children[i].getAttribute('tabindex') === '-1') {
            var childElement = document.getElementById(children[i].id);
            childElement !== null && childElement.focus();
            break;
          }
        }
      }
      if (event.key === "ArrowUp") {
        var inputElem = document.getElementById(_this.props.dropdownId);
        inputElem !== null && inputElem.focus();
      }
      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
        var _inputElem = document.getElementById(_this.props.dropdownId);
        _inputElem !== null && _inputElem.focus();
        _this.closeDropdown();
      }
      if (event.key === "Tab") {
        _this.stickyFooterFocus();
      }
      if (_this.props.searchOnKeyPress) {
        _this.props.searchOnKeyPress(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onListKeyDown", function (event) {
      // Enter or space selects an option and returns focus to the textbox
      if (event.key === "Enter" || event.key === " " || event.key === "Space") {
        _this.onOptionClick(event);
        var inputElem = document.getElementById(_this.props.dropdownId);
        inputElem !== null && inputElem.focus();
      }
      // Arrow keys navigate through selectable options
      // Up arrow on first option returns focus to the textbox (but doesn't close list)
      if (event.key === "ArrowDown") {
        var targetElem = event.target.nextSibling;
        while (targetElem && targetElem.getAttribute('tabindex') !== '-1') {
          targetElem = targetElem.nextSibling;
        }
        targetElem !== null && targetElem.focus();
      }
      if (event.key === "ArrowUp") {
        var _targetElem = event.target.previousSibling;
        while (_targetElem && _targetElem.getAttribute('tabindex') !== '-1') {
          _targetElem = _targetElem.previousSibling;
        }
        _targetElem !== null && _targetElem.focus();
        if (_targetElem === null) {
          if (_this.props.searchBox) {
            var searchElem = document.getElementById("".concat(_this.props.dropdownId, "-search"));
            searchElem !== null && searchElem.focus();
          } else {
            var _inputElem2 = document.getElementById(_this.props.dropdownId);
            _inputElem2 !== null && _inputElem2.focus();
          }
        }
      }
      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
        var _inputElem3 = document.getElementById(_this.props.dropdownId);
        _inputElem3 !== null && _inputElem3.focus();
        _this.closeDropdown();
      }

      // When we tab out, close the dropdown
      if (event.key === "Tab") {
        _this.stickyFooterFocus();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      var _document$getElementB;
      if (event.key === "Enter" || event.key === " " || event.key === "Space") {
        _this.toggleDropdown();
      }
      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
        if (_this.state.isOpen) {
          var inputElem = document.getElementById(_this.props.dropdownId);
          inputElem !== null && inputElem.focus();
          _this.closeDropdown();
        }
      }
      var dropdownContent = document.getElementById(_this.props.dropdownId + "-dropdown-options");
      if (event.key === "ArrowDown" && dropdownContent !== null) {
        if (_this.props.searchBox) {
          var searchElem = document.getElementById("".concat(_this.props.dropdownId, "-search"));
          searchElem !== null && searchElem.focus();
        } else {
          var children = dropdownContent.children;
          for (var i = 0; i < children.length; i += 1) {
            if (children[i].getAttribute('tabindex') === '-1') {
              var childElement = document.getElementById(children[i].id);
              childElement !== null && childElement.focus();
              break;
            }
          }
        }
      }
      var tagList = (_document$getElementB = document.getElementById(_this.props.dropdownId)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.querySelectorAll('.tl-tag-value');
      if (event.key === "ArrowRight" && tagList !== null && tagList !== void 0 && tagList.length) {
        var firstElement = tagList[0];
        _this.assignFocusTo(firstElement);
      }
      if (event.keyCode === 37 && tagList !== null && tagList !== void 0 && tagList.length) {
        var lastElement = tagList[tagList.length - 1];
        lastElement && lastElement.focus();
      }

      // When we tab out, close the dropdown
      if (event.key === "Tab") {
        _this.stickyFooterFocus();
      }
      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onTagKeyDown", function (event) {
      var _document$getElementB2;
      event.stopPropagation();
      var tagList = (_document$getElementB2 = document.getElementById(_this.props.dropdownId)) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.querySelectorAll('.tl-tag-value');
      if (event.keyCode && tagList !== null && tagList !== void 0 && tagList.length) {
        var tagElement = event.target;
        var itemId = tagElement.firstElementChild.innerHTML;
        var targetElem;
        switch (event.keyCode) {
          // Left Key
          case 37:
            targetElem = event.target.previousSibling;
            targetElem ? targetElem.focus() : _this.focusTheHeader();
            break;

          // Right Key
          case 39:
            targetElem = event.target.nextSibling;
            targetElem && !targetElem.classList[0].includes(emptyDivClassName) ? targetElem.focus() : _this.focusTheHeader();
            break;

          // BackSpace Key 
          case 8:
            _this.props.removeFilterSelection && _this.props.removeFilterSelection(itemId);
            _this.setState({
              optionAdded: true,
              showFromIndex: 0
            }, function () {
              var _document$getElementB3, _lastElement$firstEle;
              // if any last element is left then add focus to it
              var tagList = (_document$getElementB3 = document.getElementById(_this.props.dropdownId)) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.querySelectorAll('.tl-tag-value');
              var lastElement = tagList && tagList[tagList.length - 1];
              var withoutCross = lastElement === null || lastElement === void 0 ? void 0 : (_lastElement$firstEle = lastElement.firstElementChild) === null || _lastElement$firstEle === void 0 ? void 0 : _lastElement$firstEle.innerHTML.trim().includes('+');
              if (lastElement && !withoutCross) lastElement.focus();else {
                _this.focusTheHeader();
              }
            });
            break;

          // Enter Key
          case 13:
            itemId.trim().includes('+') && _this.setState({
              showFromIndex: 0
            }, function () {
              return _this.focusTheHeader();
            });
            break;

          // tab key
          // case 9: 
          //     this.focusTheHeader()

          default:
            break;
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "toggleDropdown", function () {
      if (_this.props.disabled) return false;
      if (_this.state.isOpen) {
        _this.closeDropdown();
      } else _this.setState({
        isOpen: true,
        dropdownUntouched: false
      });
      if (_this.props.onClick) {
        _this.props.onClick(!_this.state.isOpen);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "openDropdown", function () {
      if (!_this.state.isOpen) {
        _this.setState({
          isOpen: true
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "closeDropdown", function () {
      if (_this.state.isOpen) {
        var searchText = '';
        var _event = {
          target: {
            value: searchText
          }
        };
        if (_this.props.searchOnChange) _this.props.searchOnChange(_event);
        _this.setState({
          isOpen: false,
          searchText: searchText
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "focusTheHeader", function () {
      var inputElem = document.getElementById(_this.props.dropdownId);
      inputElem && inputElem.focus();
    });
    _defineProperty(_assertThisInitialized(_this), "assignFocusTo", function (element) {
      element && element.focus();
    });
    _defineProperty(_assertThisInitialized(_this), "renderPillsTemplate", function () {
      var _this$props = _this.props,
        _this$props$pillOptio = _this$props.pillOptions,
        pillOptions = _this$props$pillOptio === void 0 ? [] : _this$props$pillOptio,
        searchBox = _this$props.searchBox;
      if (pillOptions && pillOptions !== null && pillOptions !== void 0 && pillOptions.length) {
        var options = Object.assign([], _this.props.pillOptions);
        var classStyle = searchBox ? 'tl-when-search-box' : 'tl-when-no-search-box';
        return /*#__PURE__*/React.createElement("div", {
          className: "tl-dropdown-with-pills-container ".concat(classStyle)
        }, /*#__PURE__*/React.createElement("div", {
          className: "heading16 tl-title-space"
        }, "View by"), /*#__PURE__*/React.createElement(_PillGroup.PillGroup, {
          className: "customClass",
          id: "pills01",
          items: options,
          onClick: _this.props.onPillChange
        }), /*#__PURE__*/React.createElement(_Divider.Divider, {
          className: "tl-row-underline tl-container-divider"
        }));
      }
      return '';
    });
    _this.state = {
      isOpen: false,
      dropdownUntouched: true,
      searchText: "",
      showFromIndex: 0,
      optionAdded: false
    };
    _this.innerHeaderRef = /*#__PURE__*/React.createRef();
    _this.dropdownRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  _createClass(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
      window.addEventListener('resize', this.debounced(500, this.onResizeMultiSelection));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
      window.removeEventListener('resize', this.debounced(500, this.onResizeMultiSelection));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;
      if (this.props.multiSelection) {
        var _this$innerHeaderRef$;
        if (this.innerHeaderRef.current) this.innerHeaderRef.current.scrollLeft = (_this$innerHeaderRef$ = this.innerHeaderRef.current) === null || _this$innerHeaderRef$ === void 0 ? void 0 : _this$innerHeaderRef$.scrollWidth;
        if (this.state.optionAdded) {
          var _document$getElementB4;
          // get the width of the tagcontainer
          var tagContainer = document.querySelector('.tl-tag-container');
          var widthOfTagContainer = tagContainer ? tagContainer.offsetWidth : 0;
          var tagHiddenCountEl = document.querySelector('.tl-tag-hidden-count');
          // 40px is considered for +x Tag in case it was not present in previous render
          var widthOfTagHiddenCountEl = tagHiddenCountEl ? tagHiddenCountEl.offsetWidth : 40;
          var tagHiddenCountStyles = tagHiddenCountEl ? getComputedStyle(tagHiddenCountEl) : null;
          var marginValueOfHiddenTag = tagHiddenCountStyles ? parseInt(tagHiddenCountStyles.marginRight) : 0;
          var containerWidth = widthOfTagContainer - widthOfTagHiddenCountEl - marginValueOfHiddenTag;

          // get the total length of the tags value
          var totalSizeOfTags = 0,
            showFromIndex = this.state.showFromIndex,
            optionAdded = false;
          var optionNodeList = (_document$getElementB4 = document.getElementById(this.props.dropdownId)) === null || _document$getElementB4 === void 0 ? void 0 : _document$getElementB4.querySelectorAll('.tl-tag-option-selected');
          if (optionNodeList !== null && optionNodeList !== void 0 && optionNodeList.length) {
            var _loop = function _loop() {
              var tagContainer = optionNodeList[i];
              var styles = getComputedStyle(tagContainer);
              var width = tagContainer.offsetWidth;
              var marginRight = parseInt(styles.marginRight);
              totalSizeOfTags += width + marginRight;
              if (totalSizeOfTags > containerWidth) {
                var _tagContainer$querySe, _this2$props$values;
                // find the element
                var optionValue = (_tagContainer$querySe = tagContainer.querySelector('.tl-tag-label')) === null || _tagContainer$querySe === void 0 ? void 0 : _tagContainer$querySe.textContent;
                var indexOfOptionValue = (_this2$props$values = _this2.props.values) === null || _this2$props$values === void 0 ? void 0 : _this2$props$values.findIndex(function (selected) {
                  return selected.trim() === (optionValue === null || optionValue === void 0 ? void 0 : optionValue.trim());
                });
                showFromIndex = indexOfOptionValue !== undefined && indexOfOptionValue !== -1 ? indexOfOptionValue + 1 : 0;
                return "break";
              }
            };
            /*
                Loop in the array of values from reverse and
                check if the width of Element exceeds the width of the remaining width of the element
                if yes return the count and remaining set of elements in array
            */
            for (var i = optionNodeList.length - 1; i >= 0; i--) {
              var _ret = _loop();
              if (_ret === "break") break;
            }
          }
          this.setState({
            optionAdded: optionAdded,
            showFromIndex: showFromIndex
          });
        }
      }
    }
  }, {
    key: "calculateDropdownPosition",
    value: function calculateDropdownPosition() {
      var _this$dropdownRef$cur;
      var style;
      var boundary = (_this$dropdownRef$cur = this.dropdownRef.current) === null || _this$dropdownRef$cur === void 0 ? void 0 : _this$dropdownRef$cur.getBoundingClientRect();
      if (window.innerWidth - (boundary === null || boundary === void 0 ? void 0 : boundary.right) < 280) {
        style = _objectSpread(_objectSpread({}, style), {}, {
          right: 0
        });
      }
      return style;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$pillOptio2;
      var renderAbove = false;
      var parentElem = document.getElementById(this.props.dropdownId);
      var searchHeight = 134;
      var optionHeight = Math.min(32 + this.props.options.length * 57, 314);
      var dropdownHeight = this.props.searchBox ? optionHeight + searchHeight : optionHeight;
      var marginTopStyle = {
        marginTop: '30px'
      };
      if (parentElem) {
        if (!this.props.forceOpenToward || this.props.forceOpenToward === 'auto') {
          renderAbove = window.innerHeight - parentElem.getBoundingClientRect().bottom < dropdownHeight;
        } else {
          renderAbove = this.props.forceOpenToward === 'up';
        }
      }
      if (this.props.showPills && (_this$props$pillOptio2 = this.props.pillOptions) !== null && _this$props$pillOptio2 !== void 0 && _this$props$pillOptio2.length) {
        marginTopStyle = {
          marginTop: '10px'
        };
      }
      var style = {};
      if (this.dropdownRef.current) {
        style = this.calculateDropdownPosition();
        style = style ? {
          style: style
        } : {};
      }
      return /*#__PURE__*/React.createElement("div", {
        ref: this.dropdownRef,
        id: "".concat(this.props.dropdownId, "-container"),
        className: "".concat(this.props.className, " tl-dropdown ").concat(this.props.disabled ? 'tl-dropdown-disabled' : '')
      }, this.renderHeader(), /*#__PURE__*/React.createElement("div", _extends({
        id: this.props.dropdownId + "-dropdown-content",
        className: "".concat(this.props.optionClassName, " tl-dropdown-options ").concat(!this.state.isOpen && "tl-dropdown-closed", " ").concat(renderAbove && 'tl-dropdown-above')
      }, style), this.props.searchBox && this.renderSearchBox(), this.props.showPills && this.renderPillsTemplate(), /*#__PURE__*/React.createElement("div", {
        id: this.props.dropdownId + "-dropdown-options",
        className: "tl-dropdown-options-list",
        style: this.props.searchBox ? marginTopStyle : {}
      }, this.renderOptions()), /*#__PURE__*/React.createElement("div", {
        className: "tl-dd-footer-wrapper",
        onBlur: this.stickyFooterFocus
      }, this.props.stickyFooterDiv ? this.props.stickyFooterDiv : '')));
    }
  }, {
    key: "renderSearchBox",
    value: function renderSearchBox() {
      var isReadOnly = false;
      if (this.props.emptyOptionDisplay && this.props.options.length === 0) {
        isReadOnly = true;
      }
      if (this.props.emptyOptionDisplay && this.props.options.length === 0 && this.props.emptyOptionDisplayButSearchable) {
        isReadOnly = false;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "tl-dropdown-search-container"
      }, /*#__PURE__*/React.createElement(_TextInput.TextInput, {
        id: "".concat(this.props.dropdownId, "-search"),
        className: "tl-dropdown-search ".concat(this.props.searchBarClassName),
        placeholder: this.props.searchPlaceholder || "Search",
        value: this.state.searchText,
        onChange: this.searchOnChange,
        onFocus: this.props.searchOnFocus,
        onBlur: this.props.searchOnBlur,
        onClick: this.props.searchOnClick,
        onKeyDown: this.onSearchKeyDown,
        tabIndex: 0,
        loading: this.props.searchLoading,
        readonly: isReadOnly,
        crossIcon: this.props.showCrossIcon ? this.state.searchText.length > 0 : false,
        searchIcon: this.state.searchText.length === 0,
        onCrossIconClick: this.handleCrossIconClick,
        onSearchIconClick: this.props.onSearchIconClicked
      }));
    }
  }, {
    key: "renderAssistiveText",
    value: function renderAssistiveText() {
      var content;
      if (this.props.errors && !this.state.isOpen) {
        content = this.props.errors.map(function (err, index) {
          return /*#__PURE__*/React.createElement(_Alert.Alert, {
            key: "err-".concat(index),
            name: "alert-inline-warning",
            icon: "icon-system-alert-small",
            label: err,
            labelClass: "error-message body14-light"
          });
        });
      } else if (this.props.assistiveText && (this.props.showAssistiveTextAlways || this.state.isOpen || this.state.dropdownUntouched)) {
        content = /*#__PURE__*/React.createElement(_Alert.Alert, {
          name: "alert-inline-info-tick",
          label: this.props.assistiveText,
          labelClass: "body14-light"
        });
      } else if (this.props.successMessage) {
        content = /*#__PURE__*/React.createElement(_Alert.Alert, {
          name: "alert-inline-success",
          icon: "icon-system-tick-copy",
          label: this.props.successMessage,
          labelClass: "success-message body14-light"
        });
      } else {
        content = "";
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "tl-dropdown-assistive-text"
      }, content));
    }
  }, {
    key: "highlightMatch",
    value: function highlightMatch(label, itemId) {
      label = label || label.toString();
      var searchEscapedText = this.state.searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var match = searchEscapedText ? label.toLowerCase().match(searchEscapedText.toLowerCase()) : '';
      if (match && match.index !== undefined) {
        var start = label.substring(0, match.index);
        var matchedText = label.substring(match.index, match.index + this.state.searchText.length);
        var end = label.substring(match.index + this.state.searchText.length);
        return /*#__PURE__*/React.createElement("span", {
          id: "".concat(itemId, "-text"),
          "data-item": label
        }, start, /*#__PURE__*/React.createElement("span", {
          id: "".concat(itemId, "-highlight"),
          className: "tl-dropdown-match",
          "data-item": label
        }, matchedText), end);
      } else {
        return /*#__PURE__*/React.createElement("span", {
          id: "".concat(itemId, "-text"),
          "data-item": label
        }, label);
      }
    }
  }, {
    key: "renderOption",
    value: function renderOption(option) {
      var isGroupHeader = option.children && option.children.length > 0;
      var optionSelected = this.props.highlightSelected && this.props.value === option.displayText;
      if (option.disabled) {
        return /*#__PURE__*/React.createElement("div", {
          className: "tl-dropdown-disabled-option ".concat(this.props.disabledClassName),
          key: option.itemId,
          id: option.itemId
        }, /*#__PURE__*/React.createElement("div", {
          className: 'tl-dropdown-option-left'
        }, this.props.noSearchResultIcon ? /*#__PURE__*/React.createElement(_Icon.SvgIcon, {
          name: "".concat(option.iconName),
          className: "tl-inline-alert-icon"
        }) : '', option.displayText), option.displayTextRight && /*#__PURE__*/React.createElement("div", {
          className: 'tl-dropdown-option-right'
        }, option.displayTextRight));
      } else if (option.subheader) {
        return /*#__PURE__*/React.createElement("div", {
          className: "tl-dropdown-subheader-option",
          key: option.itemId,
          id: option.itemId
        }, /*#__PURE__*/React.createElement("div", {
          className: 'tl-dropdown-option-left'
        }, option.displayText), option.displayTextRight && /*#__PURE__*/React.createElement("div", {
          className: 'tl-dropdown-option-right'
        }, option.displayTextRight));
      } else if (isGroupHeader) {
        return /*#__PURE__*/React.createElement("div", {
          className: "tl-dropdown-option tl-dropdown-header-option",
          key: option.itemId,
          id: option.itemId
        }, /*#__PURE__*/React.createElement("div", {
          className: 'tl-dropdown-option-left'
        }, option.displayText), option.displayTextRight && /*#__PURE__*/React.createElement("div", {
          className: 'tl-dropdown-option-right'
        }, option.displayTextRight));
      } else {
        return /*#__PURE__*/React.createElement("div", {
          className: "tl-dropdown-option ".concat(this.props.optionClassName, " ").concat(optionSelected ? "tl-option-selected" : ''),
          key: "".concat(this.props.dropdownId, "-").concat(option.itemId),
          id: option.itemId,
          onClick: this.onOptionClick,
          onKeyDown: this.onListKeyDown,
          tabIndex: -1,
          "data-item": option.itemId,
          "data-optionid": option.optionId
        }, /*#__PURE__*/React.createElement("div", {
          id: option.itemId,
          className: 'tl-dropdown-option-left',
          "data-item": option.itemId
        }, this.highlightMatch(option.displayText, option.itemId)), option.displayTextRight && /*#__PURE__*/React.createElement("div", {
          id: option.itemId,
          className: 'tl-dropdown-option-right'
        }, this.highlightMatch(option.displayTextRight, option.itemId)));
      }
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _this3 = this;
      if (this.props.options.length === 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "tl-dropdown-disabled-option test ".concat(this.props.disabledClassName)
        }, this.props.emptyOptionDisplay ? this.props.emptyOptionsMessage : 'There are no results');
      }
      return this.props.options.map(function (option) {
        var hasChildren = option.children && option.children.length > 0;
        if (hasChildren) {
          var _option$children;
          return /*#__PURE__*/React.createElement(React.Fragment, null, _this3.renderOption(option), (_option$children = option.children) === null || _option$children === void 0 ? void 0 : _option$children.map(function (cp) {
            return _this3.renderOption(cp);
          }));
        } else {
          return _this3.renderOption(option);
        }
      });
    }
  }]);
  return Dropdown;
}(React.Component);
exports.Dropdown = Dropdown;